import {ILevelsService} from './ILevelsService';
import {LevelsRepository} from './LevelsRepository';
import {
  CreateNewLevelInput,
  UpdateNewLevelInput,
} from '@PikaDoApp/npm-pikado-logic';
import {LevelUI} from './LevelTypes';

export class LevelsService implements ILevelsService {
  levelsRepository: LevelsRepository;
  constructor() {
    this.levelsRepository = new LevelsRepository();
  }

  async getLevels(): Promise<Array<LevelUI>> {
    let levels = await this.levelsRepository.getLevels();
    return levels;
  }

  // async getNewLevels(): Promise<Array<LevelUI>> {
  //   const levels = await this.levelsRepository.getNewLevels();
  //   return levels;
  // }

  async getNewLevelById(id: string): Promise<LevelUI | null> {
    const level = await this.levelsRepository.getNewLevelById(id);
    return level;
  }

  async createNewLevel(input: CreateNewLevelInput): Promise<LevelUI | null> {
    const createdLevel = await this.levelsRepository.createNewLevel(input);
    return createdLevel;
  }

  async updateNewLevel(input: UpdateNewLevelInput): Promise<LevelUI | null> {
    const updatedLevel = await this.levelsRepository.updateNewLevel(input);
    return updatedLevel;
  }

  async deleteNewLevel(id: string): Promise<any> {
    const result = await this.levelsRepository.deleteNewLevel(id);
    return result;
  }
}
